import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Button from '../button'
import { translate } from '../../helpers/stringHelpers'
import { formatCurrency } from '../../helpers/currencyHelpers'
import ConfigContext from '../../contexts/configContext'

const BidButton = ({ currencyCode, nextBidValue, nextBidCalculation, ...props }) => {
  const { locale } = useContext(ConfigContext)
  const bidValue = formatCurrency(locale, currencyCode, nextBidValue)
  return (
    <Button
      className='lot__action lot__action--bid'
      color='primary'
      {...props}
    >
      {translate('JspPublicCodes_JSP_BIDDING_BID')} {nextBidCalculation
        ? translate('JspPublicCodes_JSP_LISTING_PRICE_PER_QUANTITY')
          .replace('{0}', bidValue)
        : bidValue}
      {nextBidCalculation ? <small><br />{nextBidCalculation}</small> : null}
    </Button>
  )
}

BidButton.propTypes = {
  currencyCode: PropTypes.string.isRequired,
  nextBidValue: PropTypes.number.isRequired,
  nextBidCalculation: PropTypes.string
}

export default React.memo(BidButton)
